module.exports = __webpack_public_path__ + "img/sad_manyrobot.7a37b147.png";